


const SalesPersonStatusMap = {
  1: 'Active',
  2: 'Inactive'
}

const SalesPersonAppliedToMap = {
  1: 'Sales',
  2: 'Total Invoice'
}

export const SalesPersonStatus = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'Inactive' },
];

export const SalesPersonAppliedTo = [
  { value: 1, label: 'Sales' },
  { value: 2, label: 'Total Invoice' },
];

export const SalesPersonFields = [
  { key: 'id', label: 'Sales ID', type: 'number' },
  { key: 'firstName', label: 'First Name', type: 'text' },
  { key: 'lastName', label: 'Last Name', type: 'text' },
  { key: "phone1", label: "Phone 1", type: "text" },
  { key: "phone2", label: "Phone 2", type: "text" },
  { key: "phone3", label: "Phone 3", type: "text" },
  { key: "fax", label: "Fax", type: "text" },
  { key: "address", label: "Address", type: "text" },
  { key: "city", label: "City", type: "text" },
  { key: "state", label: "State", type: "text" },
  { key: "zip", label: "Zip", type: "text" },
  { key: "county", label: "County", type: "text" },
  { key: "status", label: "Status", type: "select", map: SalesPersonStatusMap, options: SalesPersonStatus },
  { key: "percent", label: "Commission", type: "number" },
  { key: "appliedTo", label: "Applied To", type: "select", map: SalesPersonAppliedToMap, options: SalesPersonAppliedTo },
];


export const GeneralInfoField = [
  { key: 'id', label: 'Sales ID' },
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' }
]


export const StatusCommissionField = [
  { key: "status", label: "Status", map: SalesPersonStatusMap },
  { key: "percent", label: "Commission" },
  { key: "appliedTo", label: "Applied To", map: SalesPersonAppliedToMap },
]

export const AddressField = [
  { key: "address", label: "Address" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zip", label: "Zip" },
  { key: "county", label: "County" },
]

export const ContactField = [
  { key: "phone1", label: "Phone 1" },
  { key: "phone2", label: "Phone 2" },
  { key: "phone3", label: "Phone 3" },
  { key: "fax", label: "Fax" },
]
